export default __webpack_public_path__ + "static/media/cyber-joom-logo2.6544a03d.png";